import React from 'react';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-white px-5 py-14 sm:px-6 sm:py-20" data-id="element-212" data-mp="1twgvaqob8894">
      <div className="mx-auto max-w-4xl" data-id="element-213" data-mp="27mkaixorv1p2">
        <h2 className="text-center font-display text-[1.7rem] font-bold leading-[1.12] text-[#0E3B42] sm:text-4xl" data-id="element-214" data-mp="27nlr1hok4ge6">
          Se ti è mai capitato questo…{' '}
          <em className="font-semibold italic text-[#17808D]" data-id="element-215" data-mp="2hjf9fhoyj43v">
            questo Percorso è stato creato per te
          </em>
        </h2>

        <ul className="mt-9 grid gap-3.5 sm:mt-12 sm:grid-cols-2 sm:gap-4" data-id="element-216" data-mp="2cnhthchlvzrm">
          {painPoints.map(point => <li key={point.text} className="flex gap-3.5 rounded-2xl border border-[#0E3B42]/10 bg-[#FBF8F3] p-4 sm:p-5" data-id="element-217" data-mp="2mjl65ca33gst">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-218" data-mp="w7nj5h5480ej">
                {point.emoji}
              </span>
              <p className="text-[14.5px] leading-snug text-[#3F5F64]" data-id="element-219" data-mp="s7wmiwswqq23">
                {point.text}
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-xl rounded-2xl bg-[#EEF6F7] p-5 text-center sm:p-6" data-id="element-220" data-mp="1s7occb0ew6x7">
          <p className="text-[15px] leading-relaxed text-[#3F5F64] sm:text-base" data-id="element-221" data-mp="1x57pf7ldidnk">
            La buona notizia è che nessuna di queste situazioni accade per
            mancanza di capacità. Accadono perché nessuno ti ha insegnato a
            seguire un Percorso Clinico.
          </p>
          <p className="mt-3 text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#17808D]" data-id="element-222" data-mp="2awcu4o3llw4r">
            Ed è esattamente ciò che troverai qui
          </p>
        </div>

        <CTAButton className="mt-9" label="Inizia a prendere decisioni con criterio" subline="Garanzia di 7 giorni · Senza rischi" data-id="element-223" data-mp="2kw3pst3wah6f" />
      </div>
    </section>;
}